import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["embeddedPassthruProps", "onClose", "onInstallComplete", "onInstallError"];
// @ts-expect-error untyped module
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import { MagpieConnection } from 'magpie-lib/connection';
import { AudienceFilter, defineMessage, defineTopic } from 'magpie-lib/models';
import { useEffect, useState } from 'react';
import { unsubscribeAll } from '../../utils/unsubscribeAll';
import * as t from 'ts-schema';
import { jsx as _jsx } from "react/jsx-runtime";
export const CloseModal = defineMessage({
  type: 'CLOSE_MODAL'
});
export const ButtonClicked = defineMessage({
  type: 'BUTTON_CLICKED',
  payloadSchema: t.object({
    buttonKey: t.string,
    listingId: t.string,
    slug: t.string,
    sourceId: t.union(t.string, t.literal(undefined))
  })
});
export const InstallComplete = defineMessage({
  type: 'INSTALL_COMPLETE'
});
export const InstallError = defineMessage({
  type: 'INSTALL_ERROR'
});
export const LoadingFinished = defineMessage({
  type: 'LOADING_FINISHED'
});
const FULLSCREEN_CUTOFF = 544;
const MAX_WIDTH = 1000;
const MAX_HEIGHT = 700;
const MARGIN_AROUND_MODAL = 100;
export const MarketplaceModalIFrameTopic = defineTopic({
  name: '@marketplace-embed/MARKETPLACE_MODAL_IFRAME',
  messages: [CloseModal, ButtonClicked, InstallComplete, InstallError, LoadingFinished],
  enableRuntimeValidation: false,
  audience: AudienceFilter.builder().build()
});
export function publishCloseModal() {
  MagpieConnection.get().forTopic(MarketplaceModalIFrameTopic).publish(CloseModal.create());
}
export function MarketplaceModalIFrame(_ref) {
  let {
      embeddedPassthruProps = {},
      onClose,
      onInstallComplete = () => {},
      onInstallError = () => {}
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [loading, setLoading] = useState(true);

  // used to max the modal fullscreen when the screen is too small
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 544);
  const [width, setWidth] = useState(MAX_WIDTH);
  const [height, setHeight] = useState(MAX_HEIGHT);
  useEffect(() => {
    const topic = MagpieConnection.get().forTopic(MarketplaceModalIFrameTopic);
    return unsubscribeAll(topic.on(CloseModal.getType(), onClose), topic.on(InstallComplete.getType(), onInstallComplete), topic.on(InstallError.getType(), onInstallError), topic.on(LoadingFinished.getType(), () => setLoading(false)));
  }, [onClose, onInstallComplete, onInstallError]);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < FULLSCREEN_CUTOFF);

      // I tried using css min, which worked on the modal but did not pass thru to the iframe properly
      setWidth(Math.min(MAX_WIDTH, window.innerWidth - MARGIN_AROUND_MODAL));
      setHeight(Math.min(MAX_HEIGHT, window.innerHeight - MARGIN_AROUND_MODAL));
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    /*#__PURE__*/
    // @ts-expect-error FIXME 2026-06-08 Issue found due to ui-addon-iframeable TS migration. See `#typesafe-ui-addon-iframeable` Slack channel for more details.
    _jsx(ModalIFrame, Object.assign({
      embeddedPassthruProps: Object.assign({}, embeddedPassthruProps),
      height: height,
      onClose: onClose,
      onEsc: onClose,
      showLoadingIndicator: loading,
      use: isMobile ? 'fullscreen' : undefined,
      width: width
    }, props))
  );
}